import LayoutBasic from '@/layouts/basic'

const meta = {
  auth: true,
}

const pre = 'notice-'

export default {
  path: '/notice',
  name: 'notice',
  redirect: {
    name: `${pre}list`,
  },
  meta,
  component: LayoutBasic,
  children: [
    {
      path: 'list',
      name: `${pre}list`,
      meta: {
        ...meta,
        title: '公告管理',
      },
      component: () => import('@/views/notice/list'),
    },
  ],
}
